import { Tooltip } from '@mui/material'
import { JSX } from 'react'

const SimpleCustomTooltip = ({
  title,
  isLoading,
  children,
  textColor,
  placement,
}: {
  title: string
  isLoading: boolean
  children: JSX.Element
  textColor?: string
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
}) => {
  return (
    <Tooltip
      arrow
      placement={placement ?? 'right'}
      title={isLoading ? 'Loading…' : title}
      // Style the tooltip container itself (removes 300px clamp + no wrap)
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 560, // <-- wider than default
            bgcolor: 'background.paper',
            color: textColor ?? 'text.primary',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 6,
            // borderRadius: 1.5,
            fontSize: 16,
            whiteSpace: 'nowrap', // belt & suspenders
          },
        },
        arrow: {
          sx: { color: 'background.paper' },
        },
      }}
    >
      {children}
    </Tooltip>
  )
}
export default SimpleCustomTooltip
